import { render, staticRenderFns } from "./tip-modal.vue?vue&type=template&id=07ee63f8"
import script from "./tip-modal.vue?vue&type=script&lang=js"
export * from "./tip-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports